import axios from "axios";

export let headers = {
	"Tenant-Access-Token": "NWE0ZTU4NWE2YTUyOWY2OTA2ZGJhODFkOTU1YmZhMWM=",
	"Tenant-Access-Key": "7d9BNIZdbyEFyQ",
};

export const BASE_URL = "https://immersive-game-india.confirmu.com";

export const api = axios.create({
	baseURL: BASE_URL,
	headers,
});
